import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormValidators } from './validator';
import {
    ClassificacaoServico,
    EnderecoComplementar, Equipamento,
    Instalacao, Leito,
    Rascunho,
    ServicoEspecializado,
    ServicosEspecializado
} from '../models/rascunho';
import { Util } from './util';

export class FormUtil {

    // OBJETOS PARA CRIACAO DE FORMULARIO

    public static FORM_IDENTIFICACAO_PRINCIPAL = {
        cnpjCpf: ['', [Validators.required, FormValidators.cpfCnpjValidator]],
        nomeEmpresarial: ['', Validators.required],
        nomeFantasia: ['', Validators.required],
        naturezaJuridica: ['', Validators.required],
        codNaturezaJuridica: [''],
        telefone: ['', [Validators.minLength(10), Validators.required]],
        email: ['', [FormValidators.emailValidator, Validators.required]],
        nomeEmpresarialMantenedora: [''],
        naturezaJuridicaMantenedora: [''],
        cnpjMantenedora: ['', FormValidators.cnpjValidator],
        cep: ['', [Validators.required, Validators.minLength(9)]],
        logradouro: ['', Validators.required],
        numeroEndereco: ['', Validators.required],
        complemento: [''],
        bairro: ['', Validators.required],
        siglaUf: ['', Validators.required],
        uf: ['', Validators.required],
        municipio: ['', Validators.required],
        idMunicipio: ['', Validators.required],
        codigoUf: [''],
        codigoIbgeMunicipio: [''],
        tipoEstrutura: ['', Validators.required],
        tipoEstruturaId: ['', Validators.required],
        latitude: ['', Validators.required],
        longitude: ['', Validators.required],
        abrangencia: [''],
        abrangenciaId: ['']
    };

    public static FORM_IDENTIFICACAO_COMPLEMENTAR = {
        cnpjAdministradorTerceiro: ['', FormValidators.cnpjValidator],
        nomeEmpresarialAdministradorTerceiro: [''],
        naturezaJuridicaAdministradorTerceiro: [''],
        distritoSanitario: [''],
        regionalSaude: [''],
        idDsei: [''],
        idDistritoSanitario: [''],
        idRegionalSaude: [''],
        dsei: [''],
        aldeia: [''],
        poloBase: [''],
        idAldeia: [''],
        idPoloBase: [''],
        entidadesAdministradoras: [''],
        tipoEntidade: [''],
        idTipoEntidade: ['']
    };

    public static FORM_ENDERECO_COMPLEMENTAR = {
        identificacao: ['', [Validators.required, Validators.maxLength(100)]],
        cep: ['', [Validators.required, Validators.minLength(9)]],
        logradouro: ['', Validators.required],
        numeroEndereco: ['', Validators.required],
        complemento: [''],
        bairro: [''],
        siglaUf: ['', Validators.required],
        codigoUf: [''],
        telefone: ['', Validators.required],
        municipio: [''],
        codigoIbgeMunicipio: [''],
        dataAtivacao: ['', Validators.required],
        dataDesativacao: [''],
        idServico: [''],
        servico: [''],
        classificacao: ['']
    };

    public static FORM_SERVICO = {
        id: [''],
        idServico: ['', Validators.required],
        servico: ['', Validators.required],
        idClassificacao: ['', Validators.required],
        classificacao: ['', Validators.required],
        idPrestador: [''],
        prestador: ['', Validators.required],
        cnes: [''],
        nomeFantasia: [''],
        idEstabelecimentoTerceirizado: [''],
        idAtendimento: ['', Validators.required],
        atendimento: ['', Validators.required],
    };

    public static FORM_CARACTERIZACAO_GERAL = {
        grupoAtividadePrincipal: ['', Validators.required],
        idGrupoAtividadePrincipal: ['', Validators.required],
        atividadePrincipal: ['', Validators.required],
        idAtividadePrincipal: ['', Validators.required],
        idTipoEstabelecimento: ['', Validators.required],
        tipoEstabelecimento: ['', Validators.required],
        codigoTipoEstabelecimentoOutros: [''],
        tipoEstabelecimentoOutros: [''],
        possuiContratoSus: [false],
        idFormaAcesso: ['', Validators.required],
        formaAcesso: ['', Validators.required],
        sempreAberto: [false],


        // Somente para controle de inclusao de atividades secundárias
        idGrupoAtividadeSecundaria: [''],
        grupoAtividadeSecundaria: [''],
        atividadeSecundaria: [''],
        idAtividadeSecundaria: [''],

        // Somente para controle de inclusao de nivel de atenção
        idTipo: [''],
        tipo: [''],
        idNivelAtencao: [''],
        nivelAtencao: [''],
        idGestao: [''],
        gestao: [''],

        // Somente para controle de inclusao de nivel de atenção
        idConvenio: [''],
        convenio: [''],

        descGestao: [''],
        esferaAdministrativa: [''],
    };

    public static FORM_RECURSOS_FISICOS_INSTALACAO = {
        id: [''],
        idTipo: ['', Validators.required],
        tipo: ['', Validators.required],
        idSubTipo: ['', Validators.required],
        subTipo: ['', Validators.required],
        idInstalacao: ['', Validators.required],
        instalacao: ['', Validators.required],
        quantidadeInstalacoes: ['', [Validators.required, Validators.min(1)]],
        quantidadeLeitos: [''],
    };

    public static FORM_RECURSOS_FISICOS_LEITOS = {
        id: [''],
        idTipo: ['', Validators.required],
        tipo: ['', Validators.required],
        codigoLeito: [''],
        detalhamento: ['', Validators.required],
        quantidadeAtivo: ['',  [
    Validators.required,
    Validators.min(1)
]],
        quantidadeNoSus: [''],
        quantidadeHabilitado: [''],
        idDetalhamento: [''],
    };

    public static FORM_RECURSOS_FISICOS_EQUIPAMENTOS = {
        id: [''],
        idTipoEquipamento: ['', Validators.required],
        tipoEquipamento: ['', Validators.required],
        idEquipamento: ['', Validators.required],
        equipamento: ['', Validators.required],
        quantidadeExistente: ['', [Validators.required, Validators.min(1)]],
        sus: [''],
        qtSus: ['']
    };

    public static createFormRecursosFisicosEquipamentos(formBuilder: FormBuilder) {
        return {
            id: [''],
            idTipoEquipamento: ['', Validators.required],
            tipoEquipamento: ['', Validators.required],
            idEquipamento: ['', Validators.required],
            equipamento: ['', Validators.required],
            codigoEquipamento : [''],
            quantidadeExistente: ['', [Validators.required, Validators.min(1)]],
            sus: [''],
            qtSus: [''],
            renem: [''],
            series: formBuilder.array([])
        }
    }

    public static FORM_MARCACAO = {
        cnes: ['', Validators.required],
        tipoMarcacao: ['', Validators.required],
        descGrupoMarcacao: ['', Validators.required],
        subGrupoMarcacao: ['', Validators.required],
        comptInicio: ['', Validators.required],
        comptFim: [''],
        portaria: ['', Validators.required],
        dataPortaria: ['', Validators.required],
        numeroLeitos: ['', Validators.required],
    };

    // METODOS DE CONVERSAO DE RASCUNHO PARA FORM

    public static preencherFormIdentificacaoPrincipal(rascunho: Rascunho, form: FormGroup, descricaoTipoEstrutura) {
        if (rascunho.estabelecimentoSaude) {
            const values = {
                // tslint:disable-next-line:max-line-length
                cnpjCpf: FormUtil.formatarCpfCnpj(rascunho.estabelecimentoSaude.cnpj ? rascunho.estabelecimentoSaude.cnpj : rascunho.estabelecimentoSaude.cpf),
                nomeEmpresarial: rascunho.estabelecimentoSaude.razaoSocial,
                nomeFantasia: rascunho.estabelecimentoSaude.nomeFantasia,
                // tslint:disable-next-line:max-line-length
                naturezaJuridica: `${rascunho.estabelecimentoSaude.naturezaJuridica} - ${rascunho.estabelecimentoSaude.naturezaJuridicaDescricao}`,
                telefone: rascunho.estabelecimentoSaude.telefone,
                email: rascunho.estabelecimentoSaude.email,
                nomeEmpresarialMantenedora: rascunho.estabelecimentoSaude.nomeMantenedora,
                naturezaJuridicaMantenedora: null,
                cnpjMantenedora: rascunho.estabelecimentoSaude.cnpjMantenedora,
                cep: FormUtil.formatarCEP(rascunho.estabelecimentoSaude.cep),
                logradouro: rascunho.estabelecimentoSaude.logradouro,
                numeroEndereco: rascunho.estabelecimentoSaude.numeroEndereco,
                complemento: rascunho.estabelecimentoSaude.complementoEndereco,
                bairro: rascunho.estabelecimentoSaude.bairro,
                siglaUf: null,
                uf: rascunho.estabelecimentoSaude.uf,
                idMunicipio: rascunho.estabelecimentoSaude.municipio,
                municipio: rascunho.estabelecimentoSaude.municipio,
                codigoIbgeMunicipio: null,
                tipoEstrutura: descricaoTipoEstrutura,
                idTipoEstrutura: rascunho.estabelecimentoSaude.tipoEstrutura,
                latitude: rascunho.estabelecimentoSaude.latitude,
                longitude: rascunho.estabelecimentoSaude.longitude,
            };
            form.patchValue(values);
            FormUtil.markAsTouched(form);
            FormUtil.updateValueAndValidity(form);
        }
    }

    public static preencherIdentificacaoComplementar(rascunho: Rascunho, form: FormGroup) {
        if (rascunho.estabelecimentoSaude) {
            const values = {
                cnpjAdministradorTerceiro: null,
                nomeEmpresarialAdministradorTerceiro: null,
                naturezaJuridicaAdministradorTerceiro: null,
                distritoSanitario: rascunho.estabelecimentoSaude.codigoDistritoSanitario,
                regionalSaude: rascunho.estabelecimentoSaude.codigoRegiaoSaude,
                idDsei: null,
                dsei: null,
                idPoloBase: null,
                poloBase: null,
                idAldeia: null,
                aldeia: null,
                idRegionalSaude: null,
                idDistritoSanitario: null
            };
            if (rascunho.dadosIndigenas) {
                values.dsei = rascunho.dadosIndigenas.nomeDsei;
                values.poloBase = rascunho.dadosIndigenas.poloBase;
                values.aldeia = rascunho.dadosIndigenas.nomeAldeia;
            }
            form.patchValue(values);
            FormUtil.markAsTouched(form);
            FormUtil.updateValueAndValidity(form);
        }
    }

    public static preencherEnderecoComplementar(endereco: EnderecoComplementar, form: FormGroup) {
        const values = {
            identificacao: endereco.identificacao,
            cep: endereco.cep,
            logradouro: endereco.nomeLogradouro,
            numeroEndereco: endereco.numeroEndereco,
            complemento: endereco.nomeComplemento,
            bairro: endereco.bairro,
            siglaUf: null,
            telefone: endereco.telefone,
            municipio: null,
            codigoIbgeMunicipio: endereco.ibgeMunicipio,
            dataAtivacao: endereco.dataAtivacao,
            dataDesativacao: endereco.dataDesativacao,
        };
        form.patchValue(values);
        FormUtil.markAsTouched(form);
        FormUtil.updateValueAndValidity(form);
    }

    // tslint:disable-next-line:max-line-length
    public static preencherCaracterizacaoGeral(rascunho: Rascunho, form: FormGroup, tipoEstabelecimento: { codigo: string, descricao: string }) {
        const values = {
            grupoAtividadePrincipal: null,
            idGrupoAtividadePrincipal: null,
            atividadePrincipal: null,
            idAtividadePrincipal: null,
            grupoAtividadeSecundaria: null,
            idGrupoAtividadeSecundaria: null,
            atividadeSecundaria: null,
            idAtividadeSecundaria: null,
            atividadesSecundarias: null,
            idTipoEstabelecimento: tipoEstabelecimento.codigo,
            tipoEstabelecimento: tipoEstabelecimento.descricao,
            tipo: null,
            gestao: null,
            nivelAtencao: null,
            tipos: null,
            atendimento: null,
            condicaoAtendimento: null,
            atendimentos: null,
            possuiContratoSus: null,
            idFormaAcesso: null,
            formaAcesso: null,
            sempreAberto: null,
        };

        if (rascunho.atividades) {
            values.atividadePrincipal = rascunho.atividades.atividadePrincipal.descricao;
            values.idAtividadePrincipal = rascunho.atividades.atividadePrincipal.id;
            values.grupoAtividadePrincipal = rascunho.atividades.atividadePrincipal.grupo.descricao;
            values.idGrupoAtividadePrincipal = rascunho.atividades.atividadePrincipal.grupo.id;

            if (rascunho.atividades.atividadesSecundarias) {
                values.atividadesSecundarias = rascunho.atividades.atividadesSecundarias.map(atvs => {
                    return {
                        id: atvs.id,
                        descricao: atvs.descricao,
                        grupo: atvs.grupo
                    };
                });
            }
        }

        form.patchValue(values);
        FormUtil.markAsTouched(form);
        FormUtil.updateValueAndValidity(form);
    }

    public static preencherCaracterizacaoServico(servico: ServicosEspecializado, form: FormGroup) {
        const values = {
            id: null,
            idServico: null,
            servico: servico.servicoEspecializado ? servico.servicoEspecializado.descricao : null,
            idClassificacao: null,
            classificacao: servico.classificacaoServico ? servico.classificacaoServico.descricao : null,
            idPrestador: null,
            prestador: null,
            cnes: servico.cnes,
            nomeFantasia: null,
            idAtividade: null,
            atividade: null,
        };
        form.patchValue(values);
        FormUtil.markAsTouched(form);
        FormUtil.updateValueAndValidity(form);
    }

    public static preencherRecursosFisicosInstalacao(instalaco: Instalacao, form: FormGroup) {
        const values = {
            tipo: instalaco.instalacao ? instalaco.instalacao.tipoInstalacao : null,
            subTipo: instalaco.instalacao ? instalaco.instalacao.subTipoInstalacao : null,
            instalacao: instalaco.instalacao ? instalaco.instalacao.descricao : null,
            quantidade: instalaco.quantidadeInstalacoes,
        };
        form.patchValue(values);
        FormUtil.markAsTouched(form);
        FormUtil.updateValueAndValidity(form);
    }

    public static preencherRecursosFisicosLeitos(leito: Leito, form: FormGroup) {
        const values = {
            tipo: leito.tipoLeito,
            detalhamento: leito.leito ? leito.leito.descricao : null,
            quantidadeAtivo: leito.quantidadeExistente,
            quantidadeNoSus: leito.quantidadeNoSus,
            codigoLeito: leito.codigoLeito,
        };
        form.patchValue(values);
        FormUtil.markAsTouched(form);
        FormUtil.updateValueAndValidity(form);
    }

    public static preencherRecursosFisicosEqiupamentos(equipamento: Equipamento, form: FormGroup) {
        const values = {
            tipoEquipamento: equipamento.equipamento ? equipamento.equipamento.tipoEquipamento : null,
            equipamento: equipamento.equipamento ? equipamento.equipamento.descricao : null,
            quantidade: equipamento.quantidadeExistente,
        };
        form.patchValue(values);
        FormUtil.markAsTouched(form);
        FormUtil.updateValueAndValidity(form);
    }


    // METODOS DE CONVERSAO DE FORM PARA RASCUNHO

    public static converterEnderecoComplementarParaRascunho(form: FormGroup) {
        const value = form.value;
        const response = {
            identificacao: value.identificacao,
            cep: value.cep,
            nomeLogradouro: value.logradouro,
            numeroEndereco: value.numeroEndereco,
            nomeComplemento: value.complemento,
            bairro: value.bairro,
            telefone: value.telefone,
            ibgeMunicipio: value.codigoIbgeMunicipio,
            dataAtivacao: value.dataAtivacao,
            dataDesativacao: value.dataDesativacao,
        };
        return response;
    }

    public static converterServicoEspecializadoParaRascunho(form: FormGroup, servicoEspecializado: ServicoEspecializado,
        classificacaoServico: ClassificacaoServico) {
        const value = form.value;
        const response = {
            servicoEspecializado,
            classificacaoServico,
            cnes: value.cnes,
        };
        return response;
    }

    public static converterInstalacaoParaRascunho(form: FormGroup) {
        const value = form.value;
        const instalacao = {
            tipoInstalacao: value.tipo,
            subTipoInstalacao: value.subTipo,
            descricao: value.instalacao
        };
        const response = {
            instalacao,
            quantidade: value.quantidade
        };
        return response;
    }

    public static converterLeitoParaRascunho(form: FormGroup) {
        const value = form.value;
        const leitoResponse = {
            descricao: value.detalhamento,
        };
        const response = {
            tipoLeito: value.tipo,
            leito: leitoResponse,
            quantidadeExistente: value.quantidadeAtivo,
            quantidadeNoSus: value.sus,
            codigoLeito: value.codigoLeito
        };
        return response;
    }

    public static converterEquipamentoParaRascunho(form: FormGroup) {
        const value = form.value;
        const equipamento = {
            tipoEquipamento: value.tipoEquipamento,
            descricao: value.equipamento,
        };
        const response = {
            equipamento,
            quantidadeExistente: value.quantidade,
        };
        return response;
    }

    public static converterIdentificacaoPrincipalParaRascunho(form: FormGroup) {
        const value = form.value;
        const estabelecimentoSaude = {
            codigoUnidade: '1200015701929',
            tipoPessoaJuridica: '3',
            cnpjMantenedora: null,
            nomeMantenedora: null,
            razaoSocial: value.nomeEmpresarial,
            nomeFantasia: value.nomeFantasia,
            naturezaJuridica: value.naturezaJuridica,
            cpf: null,
            cnpj: Util.removerNotDigit(value.cnpjCpf),
            cnes: '5701929',
            status: '2 - Não Cadastrado',
            tipoEstrutura: value.tipoEstruturaId,
            motivoDesabilitado: '99',
            logradouro: value.logradouro,
            numeroEndereco: value.numeroEndereco,
            bairro: value.bairro,
            cep: value.cep.replace('-', ''),
            complementoEndereco: null,
            telefone: value.telefone,
            fax: null,
            codigoRegiaoSaude: '001',
            codigoDistritoSanitario: null,
            codigoDistritoAdministrativo: null,
            email: value.email,
            fluxoClientela: '03',
            uf: value.ufIbge,
            municipio: value.municipio,
            microRegiao: null,
            dataAtualizacao: '28/08/2020',
            tipoEstabelecimento: '016',
            dataCompetenciaInicio: '',
            dataCompetenciaFim: '',
            url: null,
            latitude: value.latitude,
            longitude: value.longitude,
            contratoFormalizado: null,
            tipoGestao: 'E'
        };
        const response = {
            estabelecimentoSaude
        };
        return response;
    }

    public static converterCaracterizacaoGeralParaRascunho(form: FormGroup, listAtividades: Array<{ id: any }>) {
        const value = form.value;
        const atividades = {
            atividadePrincipal: {
                id: value.idAtividadePrincipal,
                descricao: value.atividadePrincipal,
                grupo: {
                    id: value.idGrupoAtividadePrincipal,
                    descricao: value.grupoAtividadePrincipal
                }
            },
            atividadesSecundarias: listAtividades
        };
        return {
            atividades
        };
    }

    // METODOS UTEIS PARA FORM

    public static markAsTouched(form: FormGroup) {
        (Object as any).values(form.controls).forEach(control => {
            control.markAsTouched();
            control.updateValueAndValidity();
        });
    }

    public static updateValueAndValidity(form: FormGroup) {
        (Object as any).values(form.controls).forEach(control => {
            control.updateValueAndValidity();
        });
    }

    public static formatarCpfCnpj(value) {
        if (value) {
            const onlyNumbers = value.replace(/[^a-zA-Z0-9]/g, '');
            value = onlyNumbers.length <= 11
                ? Util.getMascaraCPF(onlyNumbers)
                : Util.getMascaraCNPJ(onlyNumbers);
            return value;
        } else {
            return '';
        }

    }

    public static formatarCEP(value) {
        if (value) {
            return value.substring(0, 5) + `-` + value.substring(5);
        }
    }

    public static formatarTel(value) {
        if (value && value.length === 11) {
            return `(` + value.substring(0, 2) + `) ` + value.substring(2, 7) + `-` + value.substring(7, 11);
        } else {
            return `(` + value.substring(0, 2) + `) ` + value.substring(2, 6) + `-` + value.substring(6, 10);
        }
    }

    public static sortByDate(arr, field, order) {
        if (order === 'ASC') {
            return arr.slice().sort((a, b) => {
                const dateA = new Date(a[field]).getTime();
                const dateB = new Date(b[field]).getTime();
                return dateA - dateB;
            });
        } else if (order === 'DESC') {
            return arr.slice().sort((a, b) => {
                const dateA = new Date(a[field]).getTime();
                const dateB = new Date(b[field]).getTime();
                return dateB - dateA;
            });
        }
    }

    public static sortByString(arr, field, order) {
        if (order === 'ASC') {
            return arr.slice().sort((a, b) => {
                const stringA = String(a[field]);
                const stringB = String(b[field]);
                return stringA.localeCompare(stringB);
            });
        } else if (order === 'DESC') {
            return arr.slice().sort((a, b) => {
                const stringA = String(a[field]);
                const stringB = String(b[field]);
                return stringB.localeCompare(stringA);
            });
        }
    }

    public static paginateArray(items, itemsPerPage, currentPage, totalPage) {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return items.slice(startIndex, endIndex);
    }

}
